// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 2V4H11V2H8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2V6H13V2H16.4142L22 7.58579V22H18V15H6V22H2V2H6Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 22H16V17H8V22Z"}}]};

const SaveFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'save-filled',
    ref,
    icon: element,
  },
));

SaveFilledIcon.displayName = 'SaveFilledIcon';

export default SaveFilledIcon;
